import { MAX_ETAPES } from '@carte/contrats/tournees';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ListeTournees } from '../tournee/ListeTournees';
import { lireDepuis } from '../tournee/modele';

/** `ajouter=12` ou `ajouter=12,15,18` : liste d'identifiants, doublons retirés. */
function versListe(valeur: unknown): unknown {
  if (typeof valeur === 'number') return [valeur];
  if (typeof valeur === 'string') return valeur.split(',').filter((x) => x.trim() !== '');
  return valeur;
}

/**
 * Forme canonique réécrite dans l'URL par le routeur : un nombre seul (`ajouter=12`) ou une chaîne
 * `12,15`. Un tableau serait sérialisé en JSON (`ajouter=%5B12%5D`), illisible et hors contrat.
 */
function versUrl(ids: number[]): number | string {
  return ids.length === 1 ? (ids[0] as number) : ids.join(',');
}

/** Identifiants à rattacher, relus depuis la forme canonique. */
function lireAjouter(valeur: number | string | undefined): number[] | undefined {
  if (valeur === undefined) return undefined;
  if (typeof valeur === 'number') return [valeur];
  return valeur.split(',').map(Number);
}

const rechercheSchema = z.object({
  /** Clients à rattacher à une tournée (fiche, carte ou « Autour de moi »). */
  ajouter: z
    .preprocess(versListe, z.array(z.coerce.number().int().positive()).min(1).max(MAX_ETAPES))
    .transform((ids) => versUrl([...new Set(ids)]))
    .optional()
    .catch(undefined),
  /** Point de départ proposé, au format `lon,lat` (point posé sur la carte ou position du client). */
  depuis: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/tournees/')({
  validateSearch: rechercheSchema,
  component: function PageTournees() {
    const { ajouter, depuis } = Route.useSearch();
    return <ListeTournees ajouter={lireAjouter(ajouter)} depuis={lireDepuis(depuis)} />;
  },
});
